import { Theme, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useIsAdmin } from "hooks/settings";
import { FALLBACK_TEXT } from "./errorUtils";

/**
 * Safe hook wrappers that return fallback values instead of throwing
 */
export const useSafeTheme = (): Theme | null => {
  try {
    return useTheme();
  } catch {
    return null;
  }
};

export const useSafeTranslation = () => {
  try {
    // eslint-disable-next-line @eslint-react/rules-of-hooks -- intentionally catching hook errors in error boundary context
    const { t } = useTranslation();
    // Test that t() actually works
    const testResult = t("globalErrorTitle");
    if (typeof testResult !== "string") {
      throw new Error("Translation not working");
    }
    return { t, isWorking: true };
  } catch {
    return {
      t: (key: string) => FALLBACK_TEXT[key] ?? key,
      isWorking: false,
    };
  }
};

export const useSafeIsAdmin = (): boolean => {
  try {
    return useIsAdmin();
  } catch {
    return false;
  }
};
